import bubbleBackgroung from "../assets/webp/bubbleBackgroung.webp";
import OnboardingForm from "../component/onbordingForm";
import FaqSect from "../homePage/faqSect";
import Footer from "../homePage/Footer";
import washfoldTwo from '../assets/webp/washfoldTwo.webp';
import washfoldOne from '../assets/webp/washfoldOne.webp';
import { TbUserStar } from "react-icons/tb";
import { RiShirtLine } from "react-icons/ri";
import { LuWashingMachine } from "react-icons/lu";
import { MdOutlineDryCleaning } from "react-icons/md";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useNavigate } from "react-router-dom";
import deliveryVan from '../assets/webp/deliveryVan.webp';
import { MdOutlineInventory } from "react-icons/md";
import { GrDeliver } from "react-icons/gr";
import { faqsForDeliveryPartners } from "../constants/homePageConstant";
import AppDownloadBadges from "../component/AppDownloadBadges";



export default function BusinessPage() {
  const navigate = useNavigate();

  const handleGetInTouch = () => {
    navigate('/auth/account?role=' + encodeURIComponent('delivery user'), { replace: true });
  };

  return (
    <div className="font-poppins h-[calc(100vh-80px)] mt-[80px] overflow-y-auto scrollbar-hide">
         <section
        // id="home"
        className="relative w-full h-[calc(100vh-75px)] bg-no-repeat bg-cover bg-top"
        style={{ backgroundImage: `url(${bubbleBackgroung})` }}
      >
        <div className="relative z-20 w-full flex justify-center items-center h-full mx-auto gap-10">
          <div>
            <h1 className="text-[#023B64] font-bold text-[24px] md:text-[38px] leading-tight mb-2 drop-shadow-lg">
              Are you interested to <br /> become delivery partner <br /> with
              TYDII.
            </h1>
            <p className="text-[#242B33] text-sm md:text-base max-w-xl mb-8 drop-shadow">
              We provide commercial laundry services for your business, whether
              you run a residential building, gym, spa, hotel, restaurant, or
              other type of operation. From recurring service and scheduled
              pickups to on-demand solutions, we take care of everything from
              linens and towels to uniforms, specialty fabrics, and bulk
              laundry.
            </p>
            <div className="bg-gradient-to-r from-[#E8F9FF] to-[#C8F0F9] rounded-md shadow-sm p-4 md:p-6 border-l-4 border-[#023B64] max-w-xl ">
              <p className="italic text-[#02486E] font-[600] text-sm md:text-base">
                Get in touch today to learn how we can customize commercial
                laundry services for your business—based on your schedule,
                volume, and unique industry needs.
              </p>
            </div>
            <div className="mt-6 max-w-xl">
              <p className="text-[#023B64] font-semibold text-sm mb-3">
                Download the Tydii Driver app
              </p>
              <AppDownloadBadges appType="driver" />
            </div>
                <div className="flex  md:hidden justify-between w-[280px] items-center gap-2 bg-white rounded-full pr-1 pl-4 py-1 shadow-lg">
              <div className="text-left px-4">
                <div className="font-[600] text-lg text-[#1E1F21]">Get Started</div>
              </div>
              <button
                onClick={() => handleGetInTouch()}
                className="ml-10 h-10 w-10 flex justify-center items-center rounded-full bg-[#02537F] hover:bg-[#096597] transition-colors text-white"
              >
                <ArrowForwardOutlinedIcon className="w-10 h-3" />
              </button>
            </div>
          </div>
          <div className="hidden md:block">
          <OnboardingForm userTypes='delivery user'/>
          </div>
        </div>
      </section>

      <div className="flex flex-col justify-center items-center relative overflow-visible ml-4 md:ml-6 lg:ml-14  mr-4 md:mr-6 lg:mr-4 py:6 md:py-12 ">
        {/* Decorative background shape */}
        <div
          className="absolute -left-32 bottom-0 w-[400px] h-[220px] bg-[#f1f4f1] rounded-t-[200px] opacity-80 z-0"
          style={{ filter: 'blur(2px)' }}
          aria-hidden="true"
        />
        <div className="w-full mx-auto flex flex-col md:flex-row justify-center items-center md:items-start gap-4 lg:gap-10 xl:gap-20">
          <div className="relative w-full max-w-[360px] sm:max-w-[420px] md:max-w-[450px] aspect-[4/3]" >
            {/* Card 1 */}
            <div className="absolute inset-0 mt-2 md:mt-3 w-[70%] h-[70%]  lgs:w-[78%] lgs:h-[78%] border-8 border-white rounded-tl-[30px] rounded-br-[30px] shadow-md overflow-hidden">
              <img src={deliveryVan} alt="Delivery Van" className="w-full h-full object-cover rounded-tl-[30px] rounded-br-[30px]" />
            </div>
            {/* Card 2 */}
            <div className="
        absolute bottom-4 right-4 lgs:bottom-0 lgs:right-0 md:mb-3
        w-[54%] h-[54%] lgs:w-[62%] lgs:h-[62%]
        border-8 border-white rounded-tl-[30px] rounded-br-[30px] shadow-md overflow-hidden
        md:translate-x-2 md:translate-y-2
      ">
              <img src={washfoldTwo} alt="Folded Towels" className="w-full h-full object-cover rounded-tl-[30px] rounded-br-[30px]" />
            </div>
          </div>

          {/* Right: Heading and Content */}
          <div className="flex-1">
            <div className="mb-2 text-[#1876A9] font-[600] text-[16px]">More than 25 Years of Experience</div>
            <h2 className="teext-[#323232] text-2xl lgs:text-2xl xl:text-3xl font-bold mb-4 leading-snug">Your Dry Cleaning and Laundry Done.</h2>
            <p className="text-[#50555C] text-sm lgs:text-base xl:text-lg leading-relaxed">
              We are professionals in the laundry and dry cleaning business, which means we always stay up to date on the latest technologies, cleaning methods, and solutions for dealing with stains or delicate fabrics. Plus, we maintain the highest standards of business integrity by following local and national regulations and environmental safety rules. We are passionate about changing the way you think about laundry!
            </p>
          </div>
        </div>

        {/* Stats Row */}
         <div className="flex justify-start xs:justify-center items-center w-full" >
             <div className="relative z-10 max-w-5xl  grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 text-center mb-8 md:mb-0 mt-8 md:mt-10 gap-8" >
          <div className=" flex  gap-1 lgs:gap-3 " >
            <div className="bg-[#FFFFFF] shadow-lg flex justify-center items-center h-12 w-12 text-2xl lgs:h-16lgs:w-16 lgs:text-4xl rounded-full  text-[#1876A9] ">
              <GrDeliver />
            </div>
            <div>
              <div className=" text-base sm:text-lg lg:text-3xl font-semibold text-[#323232]">10+</div>
              <div className="text-[#7B7B7B] text-xs lg:text-sm mt-1"> Delivery Partner</div>
            </div>
          </div>

                    <div className=" flex  gap-1 lgs:gap-3 ">
            <div className="bg-[#FFFFFF] shadow-lg flex justify-center items-center  h-12 w-12 text-2xl lgs:h-16lgs:w-16 lgs:text-4xl rounded-full  text-[#1876A9]">
              <MdOutlineInventory />
            </div>
            <div>
              <div className="text-base sm:text-lg lg:text-3xl font-semibold text-[#323232]">100+</div>
              <div className="text-[#7B7B7B] text-xs lg:text-sm mt-1">  Order Successfully Delivered</div>
            </div>

          </div>

          <div className=" flex gap-1 lgs:gap-3  " >
            <div className="bg-[#FFFFFF] shadow-lg flex justify-center items-center  h-12 w-12 text-2xl lgs:h-16lgs:w-16 lgs:text-4xl rounded-full  text-[#1876A9] ">
              <TbUserStar />
            </div>
            <div>
              <div className="text-base sm:text-lg lg:text-3xl  font-semibold text-[#323232]">100%</div>
              <div className="text-[#7B7B7B] text-xs lg:text-sm mt-1"> Happy Customers</div>
            </div>
          </div>


        </div>
         </div>
      </div>

      <div id="faq" className="bg-gradient-to-b from-[#F3FBFF] to-[#EEF9FF] ">
        <div className="mx-4 md:mx-6 lg:mx-14 py-6 md:py-12 ">
          <FaqSect faq={faqsForDeliveryPartners} />
        </div>
      </div>
      <div className="bg-[#034F78]">
        {" "}
        <Footer />
      </div>
    </div>
  );
}
